export default "__VITE_ASSET__D2gm68Bq__"